import React, { useEffect, useMemo, useState } from "react";
import { Chip, Typography } from "@mui/material";
import DataTablePage from "./DataTablePage";
import { toInventoryVM, toProductVM } from "../../data/mappers";
import { InventoryVM } from "../../data/types";
import { fetchInventory, fetchProducts } from "../../data/api";

const LOW = 10;

const InventoryPage: React.FC = () => {
  const [rows, setRows] = useState<InventoryVM[]>([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => { (async () => {
    try {
      const inv = (await fetchInventory() || []).map(toInventoryVM);
      if (inv.length) { setRows(inv); }
      else {
        // Fall back to product stock levels when there's no inventory table data.
        const prods = (await fetchProducts() || []).map(toProductVM);
        setRows(prods.map((p) => ({ product: p.name, quantityAvailable: p.stock })));
      }
    } finally { setLoading(false); }
  })(); }, []);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    return s ? rows.filter((r) => r.product.toLowerCase().includes(s)) : rows;
  }, [rows, q]);

  return (
    <DataTablePage<InventoryVM>
      title="Inventory" subtitle={`${rows.filter((r) => r.quantityAvailable <= LOW).length} items at or below the low-stock threshold (${LOW})`}
      search={q} onSearch={setQ} searchPlaceholder="Search product"
      loading={loading} rows={filtered} empty="No inventory records."
      columns={[
        { header: "Product", render: (r) => <Typography variant="body2" fontWeight={600}>{r.product}</Typography> },
        { header: "Qty Available", render: (r) => r.quantityAvailable },
        { header: "Status", render: (r) => {
            const low = r.quantityAvailable <= LOW;
            const out = r.quantityAvailable <= 0;
            const label = out ? "Out of Stock" : low ? "Low Stock" : "Healthy";
            const bg = out ? "#fde8e8" : low ? "#fdf0d5" : "#e7f3ec";
            const fg = out ? "#c0392b" : low ? "#b26a00" : "#1f7a4d";
            return <Chip size="small" label={label} sx={{ bgcolor: bg, color: fg, fontWeight: 600 }} />;
          } },
      ]}
    />
  );
};
export default InventoryPage;
